/**
 * Initialize required plugins for social media sharing.
 */
$(function () {

	/* FACEBOOK*/
	$.ajaxSetup({ cache: true });
	$.getScript(
		'//connect.facebook.net/en_UK/all.js#xfbml=1&status=0',
		function () {

			FB.init({
				appId: '364279916927160',
				version: lp.apiFacebookVersion || 'v2.9'
			});

			FB.getLoginStatus(function (res) {

			});

		},
		function (response) {

		}
	);

	/* GOOGLE PLUS*/
	$.getScript('https://apis.google.com/js/platform.js');

});
